// textStyles — the agent-end text-hierarchy tokens (U1, 2026-07-09).
//
// THE RULE (owner doctrine, docs/AGENT_UI_SIMPLIFICATION_REPORT.md §5.2):
// light AND dark each get a dedicated, LEGIBLE value for every hierarchy
// tier. Secondary/tertiary text must still read clearly in dark mode while
// staying visibly lower-priority than primary. Nothing below the `faint`
// tier is ever allowed — hand-picked `dark:text-neon-200/40` style classes
// are exactly the bug class this file exists to kill.
//
// Usage:  import { T } from '@baaligames/shared-ui/admin/lib/textStyles';
//         <p className={`text-sm ${T.tertiary}`}>…</p>
//
// These are plain class strings (not components) so they compose with any
// element and keep Tailwind's static extraction happy.

export const T = {
  /** Page titles, key figures, row labels. */
  primary: 'text-arena-900 dark:text-white',
  /** Section headers, emphasized helper copy. */
  secondary: 'text-arena-700 dark:text-neon-200/85',
  /** Standard helper/description copy. */
  tertiary: 'text-arena-600 dark:text-neon-200/75',
  /** Timestamps, separators, de-emphasized meta. LOWEST legal tier. */
  faint: 'text-arena-500 dark:text-neon-200/60',
} as const;
